module.exports = __webpack_public_path__ + "img/知乎.9ce83cd8.svg";